import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function AngularLogoutListener() {
  const navigate = useNavigate();

  useEffect(() => {
    const handler = () => {
      // navigate("/");
    };

    window.addEventListener("angular-logout", handler);

    return () => {
      window.removeEventListener("angular-logout", handler);
    };
  }, [navigate]);

  return null;
}
